<template>
  <div>
    <!--表格内容栏-->
    <Table :data="ruleData" />
    <!--按钮-->
    <div style="text-align: right;">
      <!--<el-button @click="reset" :disabled="disabled" size="small">重置</el-button>-->
      <el-button @click="$router.back()" size="small">返回</el-button>
      <!-- <el-button type="primary" @click="onSubmit" :disabled="disabled">提交</el-button>-->
    </div>
  </div>
</template>

<script>
import Table from "./editBooksTable";
import {
  creditRuleUpdate,
  creditRuleInfo
} from "@/api/creditRule";
import { getDataMap } from "@/api/sysParam";
import Bus from "../../../pages/creditRule/Bus";

export default {
  data() {
    return {
      ruleDialogVisible: false,
      bookDialogVisible: false,
      currentDepIndex: 0,
      ruleData: [],
      booksTypeList: [],
      ruleForm: {
        creditRuleDetails: []
      },
      resourceType: 1,
      deptId: "",
      edituuid: "",
      isAdd: false,
      disabled: true
    };
  },

  components: { Table },

  created() {
    let that = this;
    that.getSysParam("ARTICLE_TYPE");
    // Bus.$on("handleDelete", function(item) {
    //   that.handleDelete(item);
    // });
    Bus.$on("handleUpdate", function() {
      that.handleUpdate();
    });
    that.getDetail();
  },
  methods: {
    // 获取数据字典
    getSysParam(param) {
      getDataMap(param).then(res => {
        if (!res || res.code != 0) return;
        this.booksTypeList = res.data;
      });
    },
    //获取数据
    getDetail: function() {
      this.edituuid = this.$route.query.id;
      creditRuleInfo(this.edituuid).then(res => {
        if (!res || res.code != 0) return;
        const { data } = res;
        const that = this;
        const list = data.creditRuleDetails;
        if (list.length > 0) {
          list.forEach(function(creditRuleDetail) {
            that.booksTypeList.forEach(function(param) {
              if (creditRuleDetail.ruleKey === param.paramKey) {
                that.ruleData.push({
                  uuid: creditRuleDetail.uuid,
                  typeName: param.paramValue,
                  ruleKey: param.paramKey,
                  ruleValue: creditRuleDetail.ruleValue
                });
              } else {
                that.ruleData.push({
                  uuid: "",
                  typeName: param.paramValue,
                  ruleKey: param.paramKey,
                  ruleValue: ""
                });
              }
            });
          });
          this.disabled = false;
        } else {
          that.booksTypeList.forEach(function(param) {
            that.ruleData.push({
              uuid: "",
              typeName: param.paramValue,
              ruleKey: param.paramKey,
              ruleValue: ""
            });
          });
        }
      });
    },

    //返回
    cancel() {
      this.$router.back();
    },
    //重置
    reset() {
      this.$confirm(`确认重置表单吗？`, "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {})
        .catch(() => {});
    },
    //删除
    // handleDelete(item) {
    //   this.$confirm(`确认要删除该规则信息吗?`, "系统提示", {
    //     confirmButtonText: "确定",
    //     cancelButtonText: "取消",
    //     type: "warning"
    //   })
    //     .then(() => {
    //       ruleDetailDelete({ uuids: [item.uuid] }).then(res => {
    //         if (res && res.code == 0) {
    //           this.$message.success(res.msg);
    //         }
    //       });
    //     })
    //     .catch(() => {});
    // },
    //修改
    handleUpdate() {
      this.$confirm(`确认要保存操作吗？`, "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.edituuid = this.$route.query.id;
          let that = this;
          this.ruleData.forEach(function(rule) {
            if (rule.ruleValue != null && rule.ruleValue != "") {
              that.ruleForm.creditRuleDetails.push({
                uuid: rule.uuid,
                ruleId: that.edituuid,
                ruleKey: rule.ruleKey,
                ruleValue: rule.ruleValue
              });
            }
          });
          creditRuleUpdate(this.ruleForm).then(res => {
            if (!res || res.code != 0) throw new Error(res.msg);
            this.$message.success(res.msg);
            this.$router.back();
          });
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="scss" scoped>
.role-input .el-input {
  width: 100%;
}
</style>
